import React from "react";
import { Row, Col, Table } from "reactstrap";
import FinalPlayers from "./finalPlayers";
import _ from "lodash";
import avatar from "../../../../assets/images/OCH/avatar.png";

const RoundOverScreen = (props) => {
  const param = _.get(props, "param");
  const roomData = _.get(props, "roomData");
  const user = _.get(roomData, "users");
  const players = _.get(roomData, "game_state.players");
  const roundWinner = _.get(roomData, "game_state.round_winner");
  const winner = _.filter(user, (item) => item.player_id === roundWinner);
  // const winnerUser = _.filter(user, (item) => {
  //   return item?.player_id === winner[0]?.player_id;
  // });
  return (
    <div className="pt-5 d-flex flex-wrap ochWinnerWrapper">
      <div className="och-winner-col-5">
        {/* <Col md={5}> */}
        <div className="och-winner-wrapper">
          <div className="och-winner-name">
            <h3>{param ? param.roundover_text : "Round Over!"}</h3>
            <h2>{winner[0]?.display_name} Wins!</h2>
          </div>

          <div className="och-result-table-wrapper">
            <Table>
              <tr>
                <th>{param ? param.player_label : "Player"}</th>
                <th>{param ? param.roundscore_label : "Round Score"}</th>
                <th>{param ? param.totalscore_label : "Total score"}</th>
              </tr>
              {user &&
                user.length > 0 &&
                user.map((item) => {
                  return (
                    <tr>
                      <td>
                        <div
                          className={
                            winner[0]?.player_id === item?.player_id
                              ? "result-user-profile active"
                              : "result-user-profile"
                          }
                        >
                          <img
                            // src={item.profile_image}
                            src={
                              item.profile_image.toString().includes("default-profile-icon")
                                ? avatar
                                : item.profile_image.toString().includes("profileImage")
                                ? avatar : item.profile_image
                            }
                          />
                          <p>{item.display_name}</p>
                        </div>
                      </td>
                      {players &&
                        players.length > 0 &&
                        players.map((player) => {
                          if (player.player_id === item.player_id) {
                            return (
                              <>
                                <td>
                                  <p className={winner[0]?.player_id === item?.player_id ? "score active" : "score"}>
                                    {player.score}
                                  </p>
                                </td>
                                <td>
                                  <p className="score">{player.total_score ? player.total_score : "0"}</p>
                                </td>
                              </>
                            );
                          }
                        })}
                    </tr>
                  );
                })}
            </Table>
          </div>
        </div>
      </div>
      <div className="och-winner-col-7">
        <FinalPlayers />
      </div>
      {/* <Col md={7}> */}
    </div>
  );
};
export default RoundOverScreen;
